/**
 * Collection Archive Frontend JS
 * 
 * Скрипт для работы с модальным окном фильтров на фронтенде
 */

document.addEventListener('DOMContentLoaded', function () {
	// Создаем резервный объект wallcoverData, если он не существует
	if (typeof wallcoverData === 'undefined') {
		window.wallcoverData = {
			ajaxUrl: '/wp-admin/admin-ajax.php',
			nonce: ''
		};
	}
	// Fallback REST: wp_head выводит <link rel="https://api.w.org/" href=".../wp-json/" />
	if (
		!wallcoverData.collectionFilterRestUrl &&
		typeof document !== 'undefined'
	) {
		const apiLink = document.querySelector('link[rel="https://api.w.org/"]');
		if (apiLink && apiLink.href) {
			const root = apiLink.href.replace(/\/?$/, '/');
			wallcoverData.collectionFilterRestUrl =
				root + 'wallcover/v1/filter-collection-products';
		}
	}

	// Глобальные состояния переключателей
	let filterState = {
		show_all_colours: false,
		show_ready_to_ship: false,
		hide_all_colors_filter: false,
		hide_ready_to_ship_filter: false
	};

	// Инициализируем начальные состояния переключателей
	const allColoursToggle = document.getElementById('toggle-all-colours') || document.getElementById('toggle-all-colours-modal');
	const readyToShipToggle = document.getElementById('toggle-ready-to-ship') || document.getElementById('toggle-ready-to-ship-modal');

	if (allColoursToggle) {
		filterState.show_all_colours = allColoursToggle.checked;
	}

	if (readyToShipToggle) {
		filterState.show_ready_to_ship = readyToShipToggle.checked;
	}

	// Инициализируем настройки видимости фильтров из data-атрибутов блока
	const collectionArchiveBlock = document.querySelector('.wp-block-wallcover-collection-archive');
	if (collectionArchiveBlock) {
		filterState.hide_all_colors_filter = collectionArchiveBlock.dataset.hideAllColorsFilter === 'true';
		filterState.hide_ready_to_ship_filter = collectionArchiveBlock.dataset.hideReadyToShipFilter === 'true';
	}

	// Filter modal functionality
	initFilterModal();

	/**
	 * Initialize filter modal functionality
	 */
	function initFilterModal() {
		// Filter button click handler
		const filterButtons = document.querySelectorAll('.filter-button');
		filterButtons.forEach(button => {
			button.addEventListener('click', function () {
				const termId = this.getAttribute('data-term-id');
				const modalId = `collection-filter-modal-${termId}`;
				const modal = document.getElementById(modalId);

				if (modal) {
					modal.style.display = 'flex';
					// Инициализируем переключатели в модальном окне после его открытия
					initModalToggleSwitches(modal);
				}
			});
		});

		// Close button click handler
		const closeButtons = document.querySelectorAll('.collection-filter-close');
		closeButtons.forEach(button => {
			button.addEventListener('click', function () {
				const modal = this.closest('.collection-filter-modal');
				if (modal) {
					modal.style.display = 'none';
				}
			});
		});

		// Close modal when clicking outside
		const modals = document.querySelectorAll('.collection-filter-modal');
		modals.forEach(modal => {
			modal.addEventListener('click', function (event) {
				if (event.target === this) {
					this.style.display = 'none';
				}
			});
		});

		// Reset button click handler
		const resetButtons = document.querySelectorAll('.collection-filter-reset');
		resetButtons.forEach(button => {
			button.addEventListener('click', function () {
				const form = this.closest('form');
				if (form) {
					// Reset all checkboxes
					const checkboxes = form.querySelectorAll('input[type="checkbox"]');
					checkboxes.forEach(checkbox => {
						checkbox.checked = false;
					});

					// Reset radio buttons (no default selection)
					const radioGroups = form.querySelectorAll('input[type="radio"][name="sort_by"]');
					radioGroups.forEach(radio => {
						radio.checked = false;
					});
				}
			});
		});

		// Form submit handler
		const filterForms = document.querySelectorAll('.collection-filter-form');
		filterForms.forEach(form => {
			form.addEventListener('submit', function (event) {
				event.preventDefault();

				const formData = new FormData(this);
				const termId = formData.get('term_id');

				// Get sort by value
				let sortBy = '';
				const sortRadios = this.querySelectorAll('input[type="radio"][name="sort_by"]');
				sortRadios.forEach(radio => {
					if (radio.checked) {
						sortBy = radio.value;
					}
				});

				// Если ничего не выбрано, оставляем пустую строку - сервер установит значение по умолчанию

				// Create filter data object with current toggle states
				const filterData = {
					term_id: termId,
					attributes: {},
					sort_by: sortBy,
					sort_explicitly_selected: sortBy !== '', // Флаг явного выбора сортировки
					show_all_colours: filterState.show_all_colours,
					show_ready_to_ship: filterState.show_ready_to_ship,
					hide_all_colors_filter: filterState.hide_all_colors_filter,
					hide_ready_to_ship_filter: filterState.hide_ready_to_ship_filter
				};

				// Get all filter sections
				const filterSections = this.querySelectorAll('.filter-section[data-attribute]');
				filterSections.forEach(section => {
					const attributeName = section.getAttribute('data-attribute');
					const selectedValues = [];

					// Get all checked checkboxes in this section
					const checkboxes = section.querySelectorAll('input[type="checkbox"]:checked');
					checkboxes.forEach(checkbox => {
						selectedValues.push(checkbox.value);
					});

					// Add to filter data if any values are selected
					if (selectedValues.length > 0) {
						filterData.attributes[attributeName] = selectedValues;
					}
				});

				// Apply filters
				applyFilters(filterData);

				// Close modal
				const modal = this.closest('.collection-filter-modal');
				if (modal) {
					modal.style.display = 'none';
				}
			});
		});

		// Toggle switches in header
		initToggleSwitches();
	}

	/**
	 * Initialize toggle switches in header and modal
	 */
	function initToggleSwitches() {
		// Функция обработки изменения переключателя
		function handleToggleChange(toggleType, isChecked) {
			// Обновляем глобальное состояние
			filterState[toggleType] = isChecked;

			// Если включаем ready-to-ship, автоматически включаем all-colours
			if (toggleType === 'show_ready_to_ship' && isChecked) {
				filterState.show_all_colours = true;
				syncToggleStates('show_all_colours', true);
			}

			// Синхронизируем состояние между десктопной и мобильной версиями
			syncToggleStates(toggleType, isChecked);

			// Get term ID from the closest filter button
			const filterButton = document.querySelector('.filter-button');
			const termId = filterButton ? filterButton.getAttribute('data-term-id') : 0;

			// Create filter data with both toggle states
			const filterData = {
				term_id: parseInt(termId),
				show_all_colours: filterState.show_all_colours,
				show_ready_to_ship: filterState.show_ready_to_ship,
				hide_all_colors_filter: filterState.hide_all_colors_filter,
				hide_ready_to_ship_filter: filterState.hide_ready_to_ship_filter
			};

			// Apply filter
			applyFilters(filterData);
		}

		// All colours toggles (только desktop, исключаем modal)
		const allColoursToggles = document.querySelectorAll('.toggle-all-colours:not([id*="modal"])');
		allColoursToggles.forEach(toggle => {
			toggle.addEventListener('change', function () {
				handleToggleChange('show_all_colours', this.checked);
			});
		});

		// Ready to ship toggles (только desktop, исключаем modal)
		const readyToShipToggles = document.querySelectorAll('.toggle-ready-to-ship:not([id*="modal"])');
		readyToShipToggles.forEach(toggle => {
			toggle.addEventListener('change', function () {
				handleToggleChange('show_ready_to_ship', this.checked);
			});
		});
	}

	/**
 * Initialize toggle switches in modal window
 */
	function initModalToggleSwitches(modal) {
		// Функция обработки изменения переключателя в модальном окне
		function handleModalToggleChange(toggleType, isChecked) {
			// Обновляем глобальное состояние
			filterState[toggleType] = isChecked;

			// Если включаем ready-to-ship, автоматически включаем all-colours
			if (toggleType === 'show_ready_to_ship' && isChecked) {
				filterState.show_all_colours = true;
				syncToggleStates('show_all_colours', true);
			}

			// Синхронизируем состояние между десктопной и мобильной версиями
			syncToggleStates(toggleType, isChecked);

			// Get term ID from the closest filter button
			const filterButton = document.querySelector('.filter-button');
			const termId = filterButton ? filterButton.getAttribute('data-term-id') : 0;

			// Create filter data with both toggle states
			const filterData = {
				term_id: parseInt(termId),
				show_all_colours: filterState.show_all_colours,
				show_ready_to_ship: filterState.show_ready_to_ship,
				hide_all_colors_filter: filterState.hide_all_colors_filter,
				hide_ready_to_ship_filter: filterState.hide_ready_to_ship_filter
			};

			// Apply filter
			applyFilters(filterData);
		}

		// Находим переключатели в конкретном модальном окне
		const modalAllColoursToggles = modal.querySelectorAll('.toggle-all-colours');
		const modalReadyToShipToggles = modal.querySelectorAll('.toggle-ready-to-ship');

		// Убираем старые обработчики событий (если есть) и добавляем новые
		modalAllColoursToggles.forEach(toggle => {
			// Клонируем элемент, чтобы удалить все обработчики событий
			const newToggle = toggle.cloneNode(true);
			toggle.parentNode.replaceChild(newToggle, toggle);

			// Добавляем новый обработчик
			newToggle.addEventListener('change', function () {
				handleModalToggleChange('show_all_colours', this.checked);
			});
		});

		modalReadyToShipToggles.forEach(toggle => {
			// Клонируем элемент, чтобы удалить все обработчики событий
			const newToggle = toggle.cloneNode(true);
			toggle.parentNode.replaceChild(newToggle, toggle);

			// Добавляем новый обработчик
			newToggle.addEventListener('change', function () {
				handleModalToggleChange('show_ready_to_ship', this.checked);
			});
		});

		// Синхронизируем состояния переключателей в модальном окне с текущим состоянием
		syncToggleStates('show_all_colours', filterState.show_all_colours);
		syncToggleStates('show_ready_to_ship', filterState.show_ready_to_ship);
	}

	/**
	 * Sync toggle states between desktop and modal versions
	 */
	function syncToggleStates(toggleType, isChecked) {
		const className = toggleType === 'show_all_colours' ? '.toggle-all-colours' : '.toggle-ready-to-ship';
		const toggles = document.querySelectorAll(className);

		toggles.forEach(toggle => {
			if (toggle.checked !== isChecked) {
				toggle.checked = isChecked;
			}
		});
	}

	/**
	 * Apply filters to products
	 * 
	 * @param {Object} filterData Filter data object
	 */
	function applyFilters(filterData) {
		const contentContainer = document.querySelector('.collection-archive-content');
		if (contentContainer) {
			contentContainer.classList.add('loading');
		}

		const applyPayload = (payload) => {
			if (!contentContainer || !payload) {
				return;
			}
			contentContainer.innerHTML = payload.html;
			if (payload.filter_state) {
				updateToggleStates(payload.filter_state);
			}
			if (payload.debug) {
				console.log('Отладочная информация:', payload.debug);
			}
		};

		const runAjax = () => {
			const data = new FormData();
			data.append('action', 'filter_collection_products');
			data.append('filter_data', JSON.stringify(filterData));
			data.append('security', wallcoverData.nonce);
			return fetch(wallcoverData.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body: data
			})
				.then((response) => response.json())
				.then((response) => {
					if (response.success) {
						applyPayload(response.data);
					} else {
						console.error('Error applying filters:', response.data);
					}
				});
		};

		const clearLoading = () => {
			if (contentContainer) {
				contentContainer.classList.remove('loading');
			}
		};

		if (wallcoverData.collectionFilterRestUrl) {
			fetch(wallcoverData.collectionFilterRestUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json'
				},
				body: JSON.stringify({
					filter_data: filterData,
					security: wallcoverData.nonce
				})
			})
				.then(async (response) => {
					const ct = (response.headers.get('content-type') || '').toLowerCase();
					if (ct.includes('text/html')) {
						console.warn(
							'[Wallcover] REST filter: ответ text/html (ожидался JSON). Часто это 404/ошибка PHP или не сработали ЧПУ. Проверь статус запроса и тело ответа. URL:',
							wallcoverData.collectionFilterRestUrl
						);
					}
					let body = {};
					try {
						body = await response.json();
					} catch (e) {
						body = {};
					}
					if (!response.ok) {
						throw new Error(body.message || 'REST filter error');
					}
					return body;
				})
				.then((body) => {
					if (body && typeof body.html === 'string') {
						applyPayload(body);
						return;
					}
					throw new Error('REST bad body');
				})
				.catch(() => {
					return runAjax().catch((error) => {
						console.error('Error applying filters:', error);
					});
				})
				.finally(clearLoading);
			return;
		}

		runAjax()
			.catch((error) => {
				console.error('Error applying filters:', error);
			})
			.finally(clearLoading);
	}

	/**
	 * Update toggle states in UI based on server response
	 * 
	 * @param {Object} serverState Filter state from server
	 */
	function updateToggleStates(serverState) {
		// Обновляем глобальное состояние
		if (serverState.show_all_colours !== undefined) {
			filterState.show_all_colours = serverState.show_all_colours;
			syncToggleStates('show_all_colours', serverState.show_all_colours);
		}

		if (serverState.show_ready_to_ship !== undefined) {
			filterState.show_ready_to_ship = serverState.show_ready_to_ship;
			syncToggleStates('show_ready_to_ship', serverState.show_ready_to_ship);
		}

		// Обновляем настройки видимости фильтров
		if (serverState.hide_all_colors_filter !== undefined) {
			filterState.hide_all_colors_filter = serverState.hide_all_colors_filter;
		}

		if (serverState.hide_ready_to_ship_filter !== undefined) {
			filterState.hide_ready_to_ship_filter = serverState.hide_ready_to_ship_filter;
		}

		// Обновляем состояние радиокнопок сортировки только если сортировка была выбрана явно
		if (serverState.sort_explicitly_selected && serverState.sort_by) {
			const sortRadios = document.querySelectorAll('input[type="radio"][name="sort_by"]');
			sortRadios.forEach(radio => {
				radio.checked = (radio.value === serverState.sort_by);
			});
		}
	}
}); 